import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is fintech software development?",
    answer: `<p>Fintech software development services produce specialized and adaptable solutions for automated financial service delivery. Fintech solutions frequently utilize AI/ML, big data, blockchain, IoT, and other advanced tools to change BFSI procedures and provide new customer experiences.</p>`,
  },
  {
    question: "Is Outsourcing a FinTech Project a Good Idea?",
    answer: `<p>Outsourcing a fintech service is still a good-to-go option, only if the fintech app development company meets your goals and vision. This step will cut the overall cost, boost productivity, and increase flexibility for the customers.</p>`,
  },
  {
    question: "What is the role of a fintech software developer?",
    answer: `<p>The role of a fintech software developer is somehow technical, like ideating, designing, building, testing, and updating the fintech software, both app and web, that banks and financial institutions use.</p><p>TekRevol, a leading fintech app development company, has hands-on experience with diversified technologies and frameworks like blockchain, AI, AR/VR, Cloud, DevOps, and a lot more. You can hire us for your next big project together.</p>`,
  },
  {
    question: "How much does it cost to develop fintech software?",
    answer: `<p>It’s very hard to predict the time frame for the creation of a Fintech software solution. However, the design could take more than 2-3 weeks with all the iteration suggestions by the clients.</p><p>Moreover, for the development, it might take around four months if the application is complex; otherwise, it will be completed in 2 months max.</p>`,
  },
  {
    question:
      "What categories of fintech software are within your development capabilities?",
    answer: `<p>TekRevol is a well-known financial software development company in the US that tries to provide best-in-class digital solutions to consumers around the world.</p><p>Our skilled team designs and develops high-end finance software that prioritizes the easy integration of APIs and other development technologies.</p>`,
  },
  {
    question: "How do I find the right fintech development company?",
    answer: `<p>Factors to Consider when Choosing a Fintech Development Company.</p>
    <ul>
    <li>Look online for financial software development companies.</li>
    <li>Check out reviews and ratings on platforms like Clutch and Upwork.</li>
    <li>Find organizations that specialize in financial software development.</li>
    <li>Ensure that developers have finance certifications and experience.</li>
    <li>Assess the company's capabilities and resources.</li>
    <li>Prioritize organizations that have strong security measures and risk mitigation procedures.</li>
    <li>Examine conformity with industry regulations and standards.</li>
    <li>Look for organizations with a proven track record of successful fintech projects.</li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Fintech Software Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
